import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {
    AbstractControl, ControlValueAccessor,
    NG_VALIDATORS,
    NG_VALUE_ACCESSOR,
    UntypedFormBuilder,
    UntypedFormGroup,
    ValidationErrors
} from "@angular/forms";
import {combineLatest, EMPTY, of, Subscription} from "rxjs";
import {arrayIsSet, GeoPointParse, isNotNullOrUndefined} from "../../providers/service/global-variables.service";
import {OpenDialogService} from "../../providers/service/open-dialog.service";
import {startWith, switchMap} from "rxjs/operators";

@Component({
    selector: 'app-search-location-form-field',
    templateUrl: './search-location-form-field.component.html',
    styleUrls: ['./search-location-form-field.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: SearchLocationFormFieldComponent
        },
        {
            provide: NG_VALIDATORS,
            multi: true,
            useExisting: SearchLocationFormFieldComponent
        }
    ],
    standalone: false
})
export class SearchLocationFormFieldComponent implements OnInit, OnDestroy, ControlValueAccessor {
    public form: UntypedFormGroup;
    @Input() enableDisabelEmitEvent = true;
    @Input() title: string | undefined;
    private subScriptions: Subscription[] = [];
    public minLat = -90;
    public maxLat = 90
    ;
    public minLng = -180;
    public maxLng = 180;

    constructor(private fb: UntypedFormBuilder,
                private dialog: OpenDialogService) {
        this.form = this.fb.group({latitude: undefined, longitude: undefined, value: undefined});
        const latitude$ = this.form.get('latitude')?.valueChanges.pipe(
            startWith(this.form.get('latitude')?.value)
        )
        const longitude$ = this.form.get('longitude')?.valueChanges.pipe(
            startWith(this.form.get('longitude')?.value)
        )
        const sub = combineLatest([latitude$, longitude$])
            .subscribe((values: any[]) => {
                let valueToSet;
                if (arrayIsSet(values) && values[0] != null && values[1] != null) {

                    let latitude = this.form.get('latitude')?.value;
                    if (latitude < this.minLat) {
                        latitude = this.minLat;
                    } else if (latitude > this.maxLat) {
                        latitude = this.maxLat;
                    }

                    let longitude = this.form.get('longitude')?.value;
                    if (longitude < this.minLng) {
                        longitude = this.minLng;
                    } else if (longitude > this.maxLng) {
                        longitude = this.maxLng;
                    }
                    valueToSet = new GeoPointParse(latitude, longitude);
                }
                if (valueToSet != null) {
                    this.form.get('value')?.setValue(valueToSet)
                } else {
                    this.form.get('value')?.reset()
                }
            })
        this.subScriptions.push(sub)
    }

    ngOnInit(): void {
    }

    ngOnDestroy() {
        this.subScriptions.forEach(s => s.unsubscribe())
    }

    unsetValue() {
        this.form.get('value')?.reset();
    }

    onTouched: Function = () => {
    };

    registerOnChange(onChange: any) {
        const sub = this.form.get('value')?.valueChanges
            .subscribe(onChange);
        if (sub instanceof Subscription) {
            this.subScriptions.push(sub);
        }
    }

    registerOnTouched(onTouched: Function) {
        this.onTouched = onTouched;
    }

    setDisabledState(disabled: boolean) {
        if (disabled) {
            this.form.disable({emitEvent: this.enableDisabelEmitEvent});
        } else {
            this.form.enable({emitEvent: this.enableDisabelEmitEvent});
        }
    }

    writeValue(value: any) {
        if (value != null && isNotNullOrUndefined(value.latitude) && isNotNullOrUndefined(value.longitude)) {
            this.form.get('latitude')?.setValue(value.latitude);
            this.form.get('longitude')?.setValue(value.longitude);
        } else {
            this.form.get('latitude')?.reset();
            this.form.get('longitude')?.reset();
        }
    }

    validate(control: AbstractControl): ValidationErrors | null {
        if (!isNotNullOrUndefined(this.form.get('value')?.validator)) {
            this.form.get('value')?.setValidators(control.validator);
        }
        if (this.form.get('value')?.valid) {
            return null;
        } else {
            return this.form.get('value')?.errors!;
        }
    }

    openMap() {
        this.dialog.openSearchPoint(this.form.get('value')?.value)
            .pipe(switchMap((p => p != null ? of(p) : EMPTY)))
            .subscribe(point => {
                this.form.get('latitude')?.setValue(point.point.lat(),{emitEvent:false})
                this.form.get('longitude')?.setValue(point.point.lng(),)
            })
    }
}
